import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { type SubmitHandler, useForm, useWatch } from 'react-hook-form';
import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import Div from 'components/Div';
import FormInput from 'components/FormInput/index';
// import type { IUserFilters} from '../types';
// import { StatusCodes } from 'types/StatusCodes';
//redux
import { useDispatch, useSelector } from 'react-redux';
// import { fetchStatesApi, fetchUtilitiesApi, fetchLoadZonesApi, fetchRateClassesApi } from '../../api/index';
import { HyperThemeDropDown, PricingState } from '../../store/state/index';
import ElectricityIcon from '@enerex/unified-ui-react/icons/ElectricityIcon';
import GasIcon from '@enerex/unified-ui-react/icons/GasIcon';
import { states } from "../../const/statesList";
import {termsOptions, RateClassifications} from "../../const";

type UserFiltersProps = {
    hide: () => void;
    filters: any;
    extra: any,
    setFilters: Dispatch<SetStateAction<any>>;
};
const emptyFilters: any = {
    commodity: '',
    stateCode: '',
    toDate: '',
    fromDate: '',
    term: ''
};

type DropdownLoadingMap = {
    states?: boolean;
    utilities?: boolean;
    rateClasses?: boolean;
    loadProfiles?: boolean;
    loadZones?: boolean;
    billingMethods?: boolean;
};

const PricingMatrixFilters = ({ hide, handleSubmit, register, errors, control, reset, dependantDropdowns, dropdownLoading }: { hide?: () => void; handleSubmit: any; register?: any; errors?: any; control?: any; reset?: any; dependantDropdowns: any; dropdownLoading?: DropdownLoadingMap; }) => {
    //const { data, isLoading, error } = getCompanyFilters();
    const dispatch = useDispatch();
    // const { utilities, loadZones, rateClasses, error } = useSelector((state: { pricing: PricingState }) => state.pricing);
    // const [selectedState, setSelectedState] = useState<string | null>(null);

    
    // const statesList = useSelector((state: { pricing: PricingState }) => state.pricing.states);
    const termsList = useSelector((state: { ranking: PricingState }) => state.ranking.terms);
    // const utilitiesList = useSelector((state: { pricing: PricingState }) => state.pricing.utilities);
    
    //if (isLoading) {
    //    return (
    //        <Div className="text-center">
    //            <LoadingIndicator />
    //        </Div>
    //    );
    //}
    const dropdownLoadingState: DropdownLoadingMap = dropdownLoading || {};
  
    return (
        <Div className="p-2">
            <Form onSubmit={handleSubmit}>
                <Form.Label>Commodity</Form.Label>
                <Div className="d-flex justify-content-between">
                    <FormInput type="radio" name="commodity" register={register} icon={<ElectricityIcon />} value={1} label="Electric" />
                    <FormInput type="radio" name="commodity" register={register} icon={<GasIcon />} value={2} label={"Nat Gas"} />
                </Div>
                {/* <FormInput type="radio" name="commodity" register={register} icon={<><ElectricityIcon /><GasIcon /></>} value={'3'} label="Both" checked disabled/> */}
                <br/>
                <FormInput
                    type="select"
                    label="State"
                    name="stateCode"
                    // register={register}
                    control={control}
                    options={dependantDropdowns.states || []}
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedState(e?.value))
                     }}
                    isLoading={dropdownLoadingState.states}
                />
                <FormInput
                    type="select"
                    label="Utility"
                    name="utility"
                    // register={register}
                    control={control}
                    options={dependantDropdowns.utilities || []}
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedTerm(e?.value))
                     }}
                    isLoading={dropdownLoadingState.utilities}
                />
                <FormInput
                    type="select"
                    label="Rate Classes"
                    name="rateClass"
                    // register={register}
                    control={control}
                    options={dependantDropdowns.rateClasses || []}
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedTerm(e?.value))
                     }}
                    isLoading={dropdownLoadingState.rateClasses}
                />
                <FormInput
                    type="select"
                    label="Load Zones"
                    name="loadZone"
                    // register={register}
                    control={control}
                    options={dependantDropdowns.loadZones || []} // TODO: Placeholder, replace with actual load zones
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedTerm(e?.value))
                     }}
                    isLoading={dropdownLoadingState.loadZones}
                />
                <FormInput
                    type="select"
                    label="Billing Method"
                    name="billingMethod"
                    // register={register}
                    control={control}
                    options={dependantDropdowns.billingMethods || []} // TODO: Placeholder, replace with actual load zones
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedTerm(e?.value))
                     }}
                    isLoading={dropdownLoadingState.billingMethods}
                />
                <FormInput
                    type="select"
                    label="Term"
                    name="term"
                    // register={register}
                    control={control}
                    options={termsList}
                    errors={errors}
                    containerClass={'mb-3'}
                    onChange={(e) => {
                        // dispatch(setSelectedTerm(e?.value))
                     }}
                />
                <FormInput
                    type="date"
                    label="From Date"
                    name="fromDate"
                    // register={register}
                    control={control}
                    // options={rateClasses}
                    errors={errors}
                    containerClass={'mb-3'}
                />
                <FormInput
                    type="date"
                    label="To Date"
                    name="toDate"
                    // register={register}
                    control={control}
                    // options={rateClasses}
                    errors={errors}
                    containerClass={'mb-3'}
                    // onChange={(e) => {
                    //     dispatch(setSelectedRateClasses(e?.value))
                    //  }}
                />
                {/* <FormInput
                    type="typeahead"
                    label="Load Zone"
                    name="loadZone"
                    multiple={true}
                    control={control}
                    options={loadZones}
                    errors={errors}
                    containerClass={'mb-3'}
                />
                <FormInput
                    type="text"
                    label="Usage"
                    placeholder="Enter Usage"
                    name="usage"
                    register={register}
                    errors={errors}
                    containerClass={'mb-3'}
                />
                <FormInput
                    type="text"
                    label="Term"
                    placeholder="Enter Term"
                    name="term"
                    register={register}
                    errors={errors}
                    containerClass={'mb-3'}
                /> */}
                <Div>
                    <Button
                        type="button"
                        variant="primary"
                        onClick={() => {
                            // setFilters(emptyFilters);
                            reset();
                            // //hide();
                            // extra?.onApply(emptyFilters);
                        }}
                    >
                        Reset
                    </Button>
                    <Button className="float-end" type="submit" variant="primary"> Apply </Button>
                </Div>
            </Form>
        </Div>
    )

};

export { PricingMatrixFilters, emptyFilters };

